import Select from 'src/shared/components/Form/Select';
import { Checkbox, ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { Step } from '../../../../../components/Step';
import WorkOffIcon from '@mui/icons-material/WorkOff';
import { formatMultipleSelected } from '../../../../utils';
import { useTranslation } from 'react-i18next';
import { SELECT_ALL_VALUE, useStep4 } from './hooks';
import { type FactorialParamsResponse } from 'src/shared/api/integrations/factorial';

type Step4Props = {
  data: FactorialParamsResponse | undefined;
};

export const Step4 = ({ data }: Step4Props) => {
  const { t } = useTranslation(['settings', 'common']);
  const { handleChange, dataToSelect, values } = useStep4(data);
  return (
    <Step
      title={`${t('integrations.step')} 4`}
      subtitle={`${t('integrations.factorial.select the leaves you want to synchronise', { ns: 'settings' })}:`}
      Icon={WorkOffIcon}
    >
      <Select
        multiple
        sx={{ width: '300px' }}
        label={t('integrations.factorial.leaves')}
        name="leaves"
        renderValue={formatMultipleSelected(dataToSelect)}
        onChange={handleChange}
      >
        <MenuItem value={SELECT_ALL_VALUE}>
          <ListItemIcon>
            <Checkbox checked={dataToSelect?.length === values?.leaves?.length} />
          </ListItemIcon>
          <ListItemText primary={t('select all', { ns: 'common' })} />
        </MenuItem>
        {dataToSelect.map(({ label, value }) => {
          return (
            <MenuItem key={label} value={value}>
              <Checkbox key={values?.leaves?.includes(value)} checked={values?.leaves?.includes(value)} />
              <ListItemText primary={label} />
            </MenuItem>
          );
        })}
      </Select>
    </Step>
  );
};
